import Button from '../atoms/Button';

interface IronSilentBannerProps {
  txHash?: string | null;
  onRetry: () => void;
  onDismiss: () => void;
}

export function IronSilentBanner({ txHash, onRetry, onDismiss }: IronSilentBannerProps) {
  return (
    <div className="mb-6 rounded border border-vermilion-100 bg-vermilion-50 p-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="font-mono text-xs uppercase tracking-hud text-vermilion-700">
            iron_silent_review
          </div>
          <p className="mt-1 text-sm leading-relaxed text-vermilion-700">
            Iron 未达成有效砍，本次议会不计费。可重新开始一次 free retry。
          </p>
          {txHash && (
            <div className="mt-2 inline-flex max-w-full rounded border border-hairline bg-paper px-3 py-1 font-mono text-xs text-ink-2">
              <span className="truncate">tx_hash: {txHash}</span>
            </div>
          )}
        </div>
        <div className="flex shrink-0 gap-2">
          <Button variant="secondary" size="sm" onClick={onDismiss}>
            关闭
          </Button>
          <Button variant="vermilion" size="sm" onClick={onRetry}>
            重新开始议会
          </Button>
        </div>
      </div>
    </div>
  );
}
